/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SaveCompanyTaxesRequest = {
  properties: {
    taxes: {
      type: 'array',
      contains: {
        type: 'CompanyTax',
      },
      isRequired: true,
    },
  },
} as const;
